
const currencies = ['USD', 'EUR','USDT', 'USDC', 'USDG', 'RLUSD']

const local_currencies = ['BRL', 'MXN', 'COP', 'CLP']

const crypto_currencies = ['USDT', 'USDC', 'USDG', 'RLUSD']

const isLocalCurrency = (currency) => {
  return local_currencies.includes(currency)
}

const isCryptoCurrency = (currency) => {
  return crypto_currencies.includes(currency)
}

const getCurrenciesSelect = () => {
  return currencies.map((currency) => {
    return { text: currency, value: currency }
  })
}

const getLocalCurrenciesSelect = () => {
  return local_currencies.map((currency) => {
    return { text: currency, value: currency }
  })
}

const getCryptoCurrenciesSelect = () => {
  return crypto_currencies.map((currency) => {
    return { text: currency, value: currency }
  })
}

const getAllCurrenciesSelect = () => {
  return [...local_currencies, ...crypto_currencies, ...currencies].map((currency) => {
    return { text: currency, value: currency }
  })
}

export { currencies, local_currencies, crypto_currencies, isLocalCurrency, isCryptoCurrency, getCurrenciesSelect, getLocalCurrenciesSelect, getCryptoCurrenciesSelect, getAllCurrenciesSelect }



// WEBPACK FOOTER //
// ./src/shared/Currencies.js